export function normalizeHex(hex: string): string {
  const value = hex.replace('#', '').trim();

  if (value.length === 3) {
    return value
      .split('')
      .map((char) => char + char)
      .join('');
  }

  return value;
}
